module.exports = __webpack_public_path__ + "img/case1.27d7cf11.png";